import React from "react";
import Render from "../../utilities/Render";
import { SOCIAL_ICON_SRC, getCopyrightYear, toTelHref } from "./footerUtils";

const Footer = props => {
  const data = props.data || {};
  const helpWebsite = data.helpWebsite || {};

  const quickLinkItems = Array.isArray(data.quickLinks1)
    ? data.quickLinks1
    : [];
  const legalLinkItems = Array.isArray(data.legalLinks) ? data.legalLinks : [];
  const socialLinkItems = (Array.isArray(data.social)
    ? data.social
    : []
  ).filter(({ icon, link }) => SOCIAL_ICON_SRC[icon] && link);

  const hasContact = Boolean(
    data.contactHeading || data.siteName || data.phoneNumber
  );
  const hasHelp = Boolean(
    data.helpHeading ||
      data.helpDescription ||
      data.helpPhoneNumber ||
      helpWebsite.url
  );
  const hasQuickLinks = Boolean(
    data.quicklinkHeading || quickLinkItems.length > 0
  );
  const hasSocial = Boolean(data.socialHeading || socialLinkItems.length > 0);

  return (
    <footer id="footer" className="bv-footer">
      <div className="bv-footer__inner container-fluid">
        {data.acknowledgement ? (
          <section
            className="bv-footer__acknowledgement"
            aria-label="Acknowledgement of Country"
          >
            <div className="bv-footer__flags">
              <img
                src={require("../../images/aboriginal-flag.svg")}
                className="bv-footer__flag"
                alt="Aboriginal flag"
                width="67"
                height="45"
              />
              <img
                src={require("../../images/torres-strait-islanders-flag.svg")}
                className="bv-footer__flag"
                alt="Torres Strait Islander flag"
                width="67"
                height="45"
              />
              <img
                src={require("../../images/inclusion-flag.svg")}
                className="bv-footer__flag"
                alt="Pride flag inclusion"
                width="67"
                height="45"
              />
            </div>
            <div className="bv-footer__acknowledgement-body">
              <p className="bv-footer__acknowledgement-text">
                {data.acknowledgement}
              </p>
              {data.inclusion ? (
                <p className="bv-footer__acknowledgement-inclusion">
                  {data.inclusion}
                </p>
              ) : null}
            </div>
          </section>
        ) : null}

        <div className="bv-footer__grid">
          {hasContact ? (
            <section
              className="bv-footer__column"
              aria-labelledby={
                data.contactHeading ? "footer-contact-heading" : undefined
              }
            >
              {data.contactHeading ? (
                <h2 className="bv-footer__heading" id="footer-contact-heading">
                  {data.contactHeading}
                </h2>
              ) : null}
              <div className="bv-footer__column-body">
                {data.siteName ? (
                  <p className="bv-footer__text">{data.siteName}</p>
                ) : null}
                {data.phoneNumber ? (
                  <a
                    className="bv-footer__link bv-footer__link--bold"
                    href={toTelHref(data.phoneNumber)}
                  >
                    {data.phoneNumber}
                  </a>
                ) : null}
              </div>
            </section>
          ) : null}

          {hasHelp ? (
            <section
              className="bv-footer__column"
              aria-labelledby={
                data.helpHeading ? "footer-help-heading" : undefined
              }
            >
              {data.helpHeading ? (
                <h2 className="bv-footer__heading" id="footer-help-heading">
                  {data.helpHeading}
                </h2>
              ) : null}
              <div className="bv-footer__column-body">
                {data.helpDescription ? (
                  <p className="bv-footer__text">{data.helpDescription}</p>
                ) : null}
                {data.helpPhoneNumber ? (
                  <a
                    className="bv-footer__link bv-footer__link--bold"
                    href={toTelHref(data.helpPhoneNumber)}
                  >
                    {data.helpPhoneNumber}
                  </a>
                ) : null}
                {helpWebsite.url ? (
                  <a
                    className="bv-footer__link bv-footer__link--bold"
                    href={helpWebsite.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {helpWebsite.label || helpWebsite.url}
                  </a>
                ) : null}
              </div>
            </section>
          ) : null}

          {hasQuickLinks ? (
            <section
              className="bv-footer__column"
              aria-labelledby={
                data.quicklinkHeading ? "footer-quick-links-heading" : undefined
              }
            >
              {data.quicklinkHeading ? (
                <h2
                  className="bv-footer__heading"
                  id="footer-quick-links-heading"
                >
                  {data.quicklinkHeading}
                </h2>
              ) : null}
              {quickLinkItems.length > 0 ? (
                <ul className="bv-footer__link-list">
                  {quickLinkItems.map((item, index) => (
                    <li key={index}>
                      <a
                        className="bv-footer__link bv-footer__link--bold"
                        href={item.pageURL}
                      >
                        {item.pageName}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          ) : null}

          {hasSocial ? (
            <section
              className="bv-footer__column"
              aria-labelledby={
                data.socialHeading ? "footer-social-heading" : undefined
              }
            >
              {data.socialHeading ? (
                <h2 className="bv-footer__heading" id="footer-social-heading">
                  {data.socialHeading}
                </h2>
              ) : null}
              {socialLinkItems.length > 0 ? (
                <ul className="bv-footer__social">
                  {socialLinkItems.map(({ icon, tagline, link }, index) => (
                    <li key={index}>
                      <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={tagline || icon}
                      >
                        <img src={SOCIAL_ICON_SRC[icon]} alt="" />
                      </a>
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          ) : null}
        </div>

        <div className="bv-footer__legal">
          <div className="bv-footer__legal-primary">
            {legalLinkItems.length > 0 ? (
              <ul className="bv-footer__legal-links">
                {legalLinkItems.map((item, index) => (
                  <li key={index}>
                    <a className="bv-footer__link" href={item.pageURL}>
                      {item.pageName}
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
            <p className="bv-footer__copyright">
              Copyright Department of Jobs, Skills, Industry and Regions{" "}
              {String.fromCharCode(169)} {getCopyrightYear()}
            </p>
          </div>
          <div className="bv-footer__logo">
            <a href="https://vic.gov.au" className="bv-footer__logo-link">
              <img
                src={require("../../images/vic-state-gov-logo.svg")}
                className="bv-footer__vic-logo"
                alt="Victorian State Government logo"
                width="121"
                height="69"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

if (typeof footerDataCMS !== "undefined") {
  Render.Component("#footer-react", footerDataCMS, Footer);
}

export default Footer;
